<section class="h-[calc(100dvh-theme(spacing.36))] min-h-0 overflow-hidden">

    <!-- Desktop Layout -->
    <div class="hidden md:grid grid-cols-[minmax(260px,360px)_minmax(0,1fr)] gap-4 h-full min-h-0">

        <div class="h-full min-h-0 flex flex-col gap-3 overflow-hidden">
            <div class="flex-shrink-0">
                <h1 class="text-xl font-semibold">Chats</h1>
            </div>

            <label class="input input-bordered flex items-center gap-2 flex-shrink-0">
                <i class="ri-search-line"></i>
                <input type="text" [(ngModel)]="searchtext" (input)="filterChats()" class="grow min-w-0" placeholder="Search chats" />
                <button class="btn btn-xs btn-circle" type="button" (click)="clear()"><i class="ri-close-line"></i></button>
            </label>

            <!-- <div role="tablist" class="tabs tabs-lifted">
                @for (tab of tabs; track $index) {
                <a role="tab" class="tab flex items-center gap-2" [ngClass]="{'tab-active': tab.value == currentTab}" (click)="currentTab = tab.value"><span>{{tab.name}}</span>
                    <span class="font-semibold text-xs w-5 flex justify-center items-center h-5 rounded-full"
                        [ngClass]="{ 'bg-green-600 text-white': currentTab == tab.value, 'bg-zinc-200 text-zinc-500': currentTab != tab.value }">
                        5
                    </span>
                </a>
                }
            </div> -->

            <div class="flex-1 min-h-0 overflow-y-auto [scrollbar-width:none] [&::-webkit-scrollbar]:hidden">
                <!-- Skeleton Loader -->
                @if (isLoading) {
                <ul class="flex flex-col gap-2 divide-y">
                    @for (i of [1,2,3,4,5]; track $index) {
                    <li class="pt-1.5">
                        <div class="flex items-center gap-3 p-3 rounded-lg animate-pulse min-w-0">
                            <div class="avatar">
                                <div class="w-10 h-10 rounded-full bg-gray-300"></div>
                            </div>
                            <div class="w-[70%] flex flex-col gap-2">
                                <div class="h-4 bg-gray-300 rounded w-3/4"></div>
                                <div class="h-3 bg-gray-200 rounded w-full"></div>
                            </div>
                            <div class="h-full gap-1 flex flex-col justify-start items-center">
                                <div class="h-3 bg-gray-300 rounded w-12"></div>
                                <div class="h-5 w-5 bg-gray-300 rounded-full"></div>
                            </div>
                        </div>
                    </li>
                    }
                </ul>
                }

                <!-- Actual Chat List -->
                @if (!isLoading) {
                <ul class="flex flex-col gap-2 divide-y">
                    @for (i of filterdchatllist; track $index) {
                    <li class="pt-1.5 cursor-pointer" (click)="selectChat(i.id)">
                        <div class="flex items-center gap-3 p-3 rounded-lg min-w-0"
                            [ngClass]="{'bg-white border border-zinc-500': i.id?.toString() == selectedChat}">
                            <div class="avatar">
                                <div class="w-10 rounded-full">
                                    <img [src]="i.profile || defaultProfileImage" alt="Tailwind-CSS-Avatar-component" />
                                </div>
                            </div>
                            <div class="flex-1 min-w-0">
                                <p class="font-semibold text-sm truncate">{{i.name}}</p>
                                <span class="line-clamp-1 text-xs"
                                    [ngClass]="i.hasUnseen ? 'text-green-600 font-medium' : 'text-zinc-500'">{{i.message}}</span>
                            </div>
                            <div class="h-full gap-1 flex flex-col justify-start items-end flex-shrink-0">
                                <span class="text-sm text-zinc-500 capitalize text-nowrap">{{i.time}}</span>
                                @if (i.unreadCount) {
                                <span
                                    class="bg-green-600 text-white font-semibold text-xs w-5 flex justify-center items-center h-5 rounded-full">{{i.unreadCount}}</span>
                                }
                            </div>
                        </div>
                    </li>
                    }
                </ul>
                }
            </div>
        </div>

        <!-- Chat Message Screen (Desktop) -->
        <div class="min-w-0 min-h-0 border-zinc-300 border overflow-hidden bg-zinc-200 rounded-xl">
            <app-chat-messages [value]="getSelectedChat()"></app-chat-messages>
        </div>
    </div>

    <!-- Mobile Layout -->
    <div class="block md:hidden h-full min-h-0 overflow-hidden">
        <!-- Chat List View (Mobile) -->
        <div class="h-full min-h-0 flex flex-col overflow-hidden" [ngClass]="{'hidden': showChatOnMobile}">
            <div class="px-3 py-3 border-b bg-white flex-shrink-0">
                <h1 class="text-xl font-semibold">Chats</h1>
            </div>

            <div class="flex-1 min-h-0 overflow-y-auto [scrollbar-width:none] [&::-webkit-scrollbar]:hidden">
                <div class="p-3">
                    <label class="input input-bordered flex items-center gap-2 mb-4">
                        <i class="ri-search-line"></i>
                        <input type="text" [(ngModel)]="searchtext" (input)="filterChats()" class="grow min-w-0" placeholder="Search chats" />
                        <button class="btn btn-xs btn-circle" type="button" (click)="clear()"><i class="ri-close-line"></i></button>
                    </label>

                    <!-- <div role="tablist" class="tabs tabs-lifted mb-4">
                        @for (tab of tabs; track $index) {
                        <a role="tab" class="tab flex items-center gap-2" [ngClass]="{'tab-active': tab.value == currentTab}" (click)="currentTab = tab.value"><span>{{tab.name}}</span>
                            <span class="font-semibold text-xs w-5 flex justify-center items-center h-5 rounded-full"
                                [ngClass]="{ 'bg-green-600 text-white': currentTab == tab.value, 'bg-zinc-200 text-zinc-500': currentTab != tab.value }">
                                5
                            </span>
                        </a>
                        }
                    </div> -->
                </div>

                <ul class="flex flex-col divide-y">
                    @for (i of filterdchatllist; track $index) {
                    <li class="cursor-pointer" (click)="openChat(i.id)">
                        <div class="flex items-center gap-3 px-3 py-3 hover:bg-gray-50 min-w-0"
                            [ngClass]="{'bg-blue-50 border-r-4 border-blue-500': i.id?.toString() == selectedChat}">
                            <div class="avatar">
                                <div class="w-10 rounded-full">
                                <img [src]="i.profile || defaultProfileImage" alt="Tailwind-CSS-Avatar-component" />
                                </div>
                            </div>
                            <div class="flex-1 min-w-0">
                                <p class="font-semibold text-sm truncate">{{i.name}}</p>
                                <span class="line-clamp-1 text-sm"
                                    [ngClass]="i.hasUnseen ? 'text-green-600 font-medium' : 'text-zinc-500'">{{i.message}}</span>
                            </div>
                            <div class="flex flex-col items-end gap-1 flex-shrink-0">
                                <span class="text-xs text-zinc-500 text-nowrap">{{i.time}}</span>
                                @if (i.unreadCount) {
                                <span
                                    class="bg-green-600 text-white font-semibold text-xs w-6 flex justify-center items-center h-6 rounded-full">{{i.unreadCount}}</span>
                                }
                            </div>
                        </div>
                    </li>
                    }
                </ul>
            </div>
        </div>

        <!-- Chat Messages View (Mobile) -->
        <div class="h-full min-h-0 flex flex-col overflow-hidden" [ngClass]="{'hidden': !showChatOnMobile}">
            <!-- Chat Messages -->
            <div class="flex-1 min-h-0 overflow-hidden">
                <app-chat-messages [value]="getSelectedChat()" (back)="backToChatList()"></app-chat-messages>
            </div>
        </div>
    </div>

</section>
